/**
 * WAKETARA × TRAX TOKYO — Shopify Section Script
 * File: assets/waketara.js
 *
 * - Intersection Observer によるスクロールフェードイン
 * - ポイントカード・ステップのスタガーアニメーション
 */

(function () {
  'use strict';

  /* ─── 対象要素にアニメーションクラスを付与 ─── */
  function initAnimations() {
    const targets = document.querySelectorAll(
      '#waketara-page .wkt-point-card, #waketara-page .wkt-step, #waketara-page .wkt-contact__card'
    );

    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add('wkt-animate');
    });

    /* ─── スタガー遅延設定 ─── */
    document.querySelectorAll('#waketara-page .wkt-point-card').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.15) + 's';
    });

    document.querySelectorAll('#waketara-page .wkt-step').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.18) + 's';
    });

    document.querySelectorAll('#waketara-page .wkt-contact__card').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.12) + 's';
    });

    /* ─── Intersection Observer ─── */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wkt-visible');
          observer.unobserve(entry.target); // 一度表示されたら監視解除
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── DOM 読み込み後に実行 ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

})();